import _ from "lodash";
import { getCloudUrl } from "Constants";

export const LE_COLLECTION = "LE_COLLECTION";
export const UNIT_PLAN = "UNIT_PLAN";
export const ASSESSMENT = "ASSESSMENT";
export const E_ASSESSMENT = "E_ASSESSMENT";
export const ALL_LE = "ALL_LE";
export const FEED_SECTION = "FEED_SECTION";
export const LE_COLLECTION_VIEW = "LE_COLLECTION_VIEW";
export const QUESTION = "QUESTION";
export const QUESTION_V2 = "QUESTION_V2";
export const WORKSHEET = "WORKSHEET";
export const MOCK_EXAM = "MOCK_EXAM";
export const PRACTICE_WORKSHEET = "PRACTICE_WORKSHEET";
export const WORKSHEET_ASSESSMENT = "WORKSHEET_ASSESSMENT";
export const CRITERION_BASED_ASSESSMENT = "CRITERION_BASED_ASSESSMENT";

// Entity type mappings
export const ENTITY_TYPE_LEARNING_EXPERIENCE = "learning_experience";
export const ENTITY_TYPE_WORKSHEET = "worksheet";

export const LIBRARY_LE_BANNER_IMAGE = `${getCloudUrl()}/assets/library_le_banner_image.jpg`;
export const LIBRARY_HOMEPAGE_BANNER_IMAGE = `${getCloudUrl()}/assets/banner_background_play.png`;
export const LIBRARY_UNITS_BANNER_IMAGE = `${getCloudUrl()}/assets/library_units_banner_image.jpg`;
export const LIBRARY_BANNER_CONCEPTUAL_IMAGE = `${getCloudUrl()}/assets/library_banner_conceptual.png`;
export const LIBRARY_BANNER_COMPHREHENSIVE_IMAGE = `${getCloudUrl()}/assets/library_banner_comprehensive.png`;
export const LIBRARY_BANNER_LEARNER_CENTRED_IMAGE = `${getCloudUrl()}/assets/library_banner_learner_centred.png`;
export const LIBRARY_BANNER_INTERESTED_IMAGE = `${getCloudUrl()}/assets/library_banner_interested.png`;
export const LIBRARY_QUESTIONS_BANNER_IMAGE = `${getCloudUrl()}/assets/questions.png`;
export const LIBRARY_WORKSHEETS_BANNER_IMAGE = `${getCloudUrl()}/assets/worksheets.png`;
export const LIBRARY_MOCK_EXAMS_BANNER_IMAGE = `${getCloudUrl()}/assets/library_banner_mock_exams.png`;

const COMMUNICATION_AND_LANGUAGE = "Communication and Language";
const EXPRESSIVE_ARTS_AND_DESIGN = "Expressive Arts and Design";
const LITERACY = "Literacy";
const PERSONAL_SOCIAL_AND_EMOTIONAL_DEVELOPMENT =
  "Personal, Social and Emotional Development";
const PHYSICAL_DEVELOPMENT = "Physical Development";
const UNDERSTANDING_THE_WORLD = "Understanding the World";
const MATHEMATICS = "Mathematics";
const ARTS = "Arts";
const ENGLISH = "English";
const SCIENCE_AND_TECHNOLOGY = "Science and Technology";
const SOCIAL_STUDIES = "Social Studies";
const MATHEMATICS_APPLICATIONS_AND_INTERPRETATION =
  "Mathematics: Applications and Interpretation";
const MATHEMATICS_APPLICATIONS_AND_INTERPRETATION_ABBREVIATION = "Math AI";
const MATHEMATICS_ANALYSIS_AND_APPROACHES =
  "Mathematics: Analysis and Approaches";
const MATHEMATICS_ANALYSIS_AND_APPROACHES_ABBREVIATION = "Math AA";
const BIOLOGY = "Biology";

export const ENGLISH_A = "English A: Language and Literature";
export const ENGLISH_A_ABBREVIATION = "Lang and Lit";

const CLOUD_ASSETS = `${getCloudUrl()}/assets`;

export const GRADE_BANNER_DATA = {
  "2-3 year olds": {
    imageUrl: `${CLOUD_ASSETS}/library_grade_2_3_yrs.png`,
    subjectBannerUrls: {
      [COMMUNICATION_AND_LANGUAGE]: `${CLOUD_ASSETS}/communication_and_language_grade_2_3_yrs.png`,
      [EXPRESSIVE_ARTS_AND_DESIGN]: `${CLOUD_ASSETS}/library_expressive_arts_grade_2_3_v2.png`,
      [LITERACY]: `${CLOUD_ASSETS}/literacy_grade_2_3.png`,
      [MATHEMATICS]: `${CLOUD_ASSETS}/mathematics_grade_2_3_yrs.png`,
      [PERSONAL_SOCIAL_AND_EMOTIONAL_DEVELOPMENT]: `${CLOUD_ASSETS}/personal_social_development_grade_2_3_yrs.png`,
      [PHYSICAL_DEVELOPMENT]: `${CLOUD_ASSETS}/physical_development_grade_2_3_yrs.png`,
      [UNDERSTANDING_THE_WORLD]: `${CLOUD_ASSETS}/understanding_the_world_grade_2_3_yrs.png`,
    },
    subText: "toddleLibrary:homepage_banner_subtext",
  },
  "3-4 year olds": {
    imageUrl: `${CLOUD_ASSETS}/grade_3_4_yrs.png`,
    subjectBannerUrls: {
      [COMMUNICATION_AND_LANGUAGE]: `${CLOUD_ASSETS}/communication_and_language_grade_3_4_yrs.png`,
      [EXPRESSIVE_ARTS_AND_DESIGN]: `${CLOUD_ASSETS}/expressive_arts_and_design_grade_3_4_yrs.png`,
      [LITERACY]: `${CLOUD_ASSETS}/literacy_grade_3_4.png`,
      [MATHEMATICS]: `${CLOUD_ASSETS}/mathematics_grade_3_4_yrs.png`,
      [PERSONAL_SOCIAL_AND_EMOTIONAL_DEVELOPMENT]: `${CLOUD_ASSETS}/personal_social_development_grade_3_4_yrs.png`,
      [PHYSICAL_DEVELOPMENT]: `${CLOUD_ASSETS}/physical_development_grade_3_4_yrs.png`,
      [UNDERSTANDING_THE_WORLD]: `${CLOUD_ASSETS}/understanding_the_world_grade_3_4_yrs.png`,
    },
    subText: "toddleLibrary:homepage_banner_subtext",
  },
  "4-6 year olds": {
    imageUrl: `${CLOUD_ASSETS}/grade_4_6_yrs.png`,
    subjectBannerUrls: {
      [COMMUNICATION_AND_LANGUAGE]: `${CLOUD_ASSETS}/communication_and_language_grade_4_6_yrs.png`,
      [EXPRESSIVE_ARTS_AND_DESIGN]: `${CLOUD_ASSETS}/library_expressive_arts_grade_4_6_v2.png`,
      [LITERACY]: `${CLOUD_ASSETS}/literacy_grade_4_6.png`,
      [MATHEMATICS]: `${CLOUD_ASSETS}/mathematics_grade_4_6_yrs.png`,
      [PERSONAL_SOCIAL_AND_EMOTIONAL_DEVELOPMENT]: `${CLOUD_ASSETS}/personal_social_development_grade_4_6_yrs.png`,
      [PHYSICAL_DEVELOPMENT]: `${CLOUD_ASSETS}/physical_development_grade_4_6_yrs.png`,
      [UNDERSTANDING_THE_WORLD]: `${CLOUD_ASSETS}/understanding_the_world_grade_4_6_yrs.png`,
    },
    subText: "toddleLibrary:homepage_banner_subtext",
  },
  "Grade 1": {
    imageUrl: `${CLOUD_ASSETS}/grade_1.png`,
    subjectBannerUrls: {
      [MATHEMATICS]: `${CLOUD_ASSETS}/mathematics_grade_1.png`,
      [PERSONAL_SOCIAL_AND_EMOTIONAL_DEVELOPMENT]: `${CLOUD_ASSETS}/personal_social_development_grade_1.png`,
      [ARTS]: `${CLOUD_ASSETS}/library_arts_grade_1_v2.png`,
      [ENGLISH]: `${CLOUD_ASSETS}/english_grade_1.png`,
      [SCIENCE_AND_TECHNOLOGY]: `${CLOUD_ASSETS}/science_and_technology_grade_2.png`,
      [SOCIAL_STUDIES]: `${CLOUD_ASSETS}/social_studies_grade_1.png`,
    },
    subText: "toddleLibrary:homepage_banner_subtext_2",
  },
  "Grade 2": {
    imageUrl: `${CLOUD_ASSETS}/library_grade_2.png`,
    subjectBannerUrls: {
      [ARTS]: `${CLOUD_ASSETS}/library_arts_grade_2_v2.png`,
      [ENGLISH]: `${CLOUD_ASSETS}/english_grade_2.png`,
      [MATHEMATICS]: `${CLOUD_ASSETS}/library_mathematics_grade_2_v2.png`,
      [PERSONAL_SOCIAL_AND_EMOTIONAL_DEVELOPMENT]: `${CLOUD_ASSETS}/library_personal_social_development_grade_2.png`,
      [SCIENCE_AND_TECHNOLOGY]: `${CLOUD_ASSETS}/library_science_and_technology_grade_2_v2.png`,
      [SOCIAL_STUDIES]: `${CLOUD_ASSETS}/social_studies_grade_2.png`,
    },
    subText: "toddleLibrary:homepage_banner_subtext_2",
  },
  "Grade 3": {
    imageUrl: `${CLOUD_ASSETS}/grade_3.png`,
    subjectBannerUrls: {
      [ARTS]: `${CLOUD_ASSETS}/library_arts_grade_3_v2.png`,
      [ENGLISH]: `${CLOUD_ASSETS}/english_grade_3.png`,
      [MATHEMATICS]: `${CLOUD_ASSETS}/library_mathematics_grade_3_v2.png`,
      [PERSONAL_SOCIAL_AND_EMOTIONAL_DEVELOPMENT]: `${CLOUD_ASSETS}/library_personal_social_development_grade_3.png`,
      [SCIENCE_AND_TECHNOLOGY]: `${CLOUD_ASSETS}/science_and_technology_grade_3.png`,
      [SOCIAL_STUDIES]: `${CLOUD_ASSETS}/social_studies_grade_3.png`,
    },
    subText: "toddleLibrary:homepage_banner_subtext_2",
  },
  "Grade 4": {
    imageUrl: `${CLOUD_ASSETS}/library_grade_4.png`,
    subjectBannerUrls: {
      [ARTS]: `${CLOUD_ASSETS}/library_arts_grade_4.png`,
      [ENGLISH]: `${CLOUD_ASSETS}/library_english_grade_4.png`,
      [MATHEMATICS]: `${CLOUD_ASSETS}/library_grade_4_mathematics.png`,
      [PERSONAL_SOCIAL_AND_EMOTIONAL_DEVELOPMENT]: `${CLOUD_ASSETS}/personal_social_development_grade_4.png`,
      [SCIENCE_AND_TECHNOLOGY]: `${CLOUD_ASSETS}/library_science_and_technology_grade_4.png`,
      [SOCIAL_STUDIES]: `${CLOUD_ASSETS}/social_studies_grade_4.png`,
    },
    subText: "toddleLibrary:homepage_banner_subtext_2",
  },
  "Grade 5": {
    imageUrl: `${CLOUD_ASSETS}/library_grade_5.png`,
    subjectBannerUrls: {
      [ARTS]: `${CLOUD_ASSETS}/library_arts_grade_5.png`,
      [ENGLISH]: `${CLOUD_ASSETS}/library_english_grade_5.png`,
      [MATHEMATICS]: `${CLOUD_ASSETS}/library_mathematics_grade_5.png`,
      [PERSONAL_SOCIAL_AND_EMOTIONAL_DEVELOPMENT]: `${CLOUD_ASSETS}/library_personal_social_development_grade_5.png`,
      [SCIENCE_AND_TECHNOLOGY]: `${CLOUD_ASSETS}/library_science_and_technology_grade_5.png`,
      [SOCIAL_STUDIES]: `${CLOUD_ASSETS}/library_social_studies_grade_5.png`,
    },
    subText: "toddleLibrary:homepage_banner_subtext_2",
  },
  "Grade 6": {
    imageUrl: `${CLOUD_ASSETS}/banner_6.png`,
    subjectBannerUrls: {},
    subText: "toddleLibrary:homepage_banner_subtext_2",
  },
  "Grade 7": {
    imageUrl: `${CLOUD_ASSETS}/banner_7.png`,
    subjectBannerUrls: {},
    subText: "toddleLibrary:homepage_banner_subtext_2",
  },
  "Grade 8": {
    imageUrl: `${CLOUD_ASSETS}/banner_8.png`,
    subjectBannerUrls: {},
    subText: "toddleLibrary:homepage_banner_subtext_2",
  },
  "Grade 9": {
    imageUrl: `${CLOUD_ASSETS}/banner_9.png`,
    subjectBannerUrls: {},
    subText: "toddleLibrary:homepage_banner_subtext_2",
  },
  "Grade 10": {
    imageUrl: `${CLOUD_ASSETS}/banner_10.png`,
    subjectBannerUrls: {},
    subText: "toddleLibrary:homepage_banner_subtext_2",
  },
  "Grade 11 & 12": {
    imageUrl: `${CLOUD_ASSETS}/library_grade_11_12.png`,
    subjectBannerUrls: {
      [MATHEMATICS_APPLICATIONS_AND_INTERPRETATION]: `${CLOUD_ASSETS}/library_math_ai_grade_11_12.png`,
      [MATHEMATICS_ANALYSIS_AND_APPROACHES]: `${CLOUD_ASSETS}/maths_aa_grade_11_12.png`,
    },
    subText: "toddleLibrary:homepage_banner_subtext_3",
  },
};

export const MYP_BANNER_DATA = {
  "Grade 6": {
    imageUrl: `${CLOUD_ASSETS}/banner_6.png`,
    subjectBannerUrls: {
      [MATHEMATICS]: `${CLOUD_ASSETS}/library_math_ai_grade_11_12.png`,
      [BIOLOGY]: `${CLOUD_ASSETS}/biology_grade_10.png`,
    },
    subText: "toddleLibrary:homepage_banner_subtext_4",
  },
  "Grade 7": {
    imageUrl: `${CLOUD_ASSETS}/banner_7.png`,
    subjectBannerUrls: {
      [MATHEMATICS]: `${CLOUD_ASSETS}/library_math_ai_grade_11_12.png`,
      [BIOLOGY]: `${CLOUD_ASSETS}/biology_grade_10.png`,
    },
    subText: "toddleLibrary:homepage_banner_subtext_4",
  },
  "Grade 8": {
    imageUrl: `${CLOUD_ASSETS}/banner_8.png`,
    subjectBannerUrls: {
      [MATHEMATICS]: `${CLOUD_ASSETS}/library_math_ai_grade_11_12.png`,
      [BIOLOGY]: `${CLOUD_ASSETS}/biology_grade_10.png`,
    },
    subText: "toddleLibrary:homepage_banner_subtext_4",
  },
  "Grade 9": {
    imageUrl: `${CLOUD_ASSETS}/banner_9.png`,
    subjectBannerUrls: {
      [MATHEMATICS]: `${CLOUD_ASSETS}/library_math_ai_grade_11_12.png`,
      [BIOLOGY]: `${CLOUD_ASSETS}/biology_grade_10.png`,
    },
    subText: "toddleLibrary:homepage_banner_subtext_4",
  },
  "Grade 10": {
    imageUrl: `${CLOUD_ASSETS}/banner_10.png`,
    subjectBannerUrls: {
      [MATHEMATICS]: `${CLOUD_ASSETS}/library_math_ai_grade_11_12.png`,
      [BIOLOGY]: `${CLOUD_ASSETS}/biology_grade_10.png`,
    },
    subText: "toddleLibrary:homepage_banner_subtext_4",
  },
};

export const TOPICS_IMAGES = {
  Functions: `${getCloudUrl()}/assets/functions.png`,
  "Geometry and trigonometry": `${getCloudUrl()}/assets/geometry.png`,
  Calculus: `${getCloudUrl()}/assets/calculus.png`,
  "Number and algebra": `${getCloudUrl()}/assets/numbers.png`,
  "Statistics and probability": `${getCloudUrl()}/assets/probability.png`,
  "Non-literary texts": `${getCloudUrl()}/assets/non-literacy.jpg`,
  "Literary texts": `${getCloudUrl()}/assets/literacy%20texts.jpg`,
  Concepts: `${getCloudUrl()}/assets/concepts.jpg`,
  AoEs: `${getCloudUrl()}/assets/AoEs.jpg`,
  Miscellaneous: `${getCloudUrl()}/assets/misc.jpg`,
  "Theme A: Unity and Diversity": `${getCloudUrl()}/assets/Unity_and_diversity.jpg`,
  "Theme B: Form and Function": `${getCloudUrl()}/assets/Form_and_function.jpg`,
  "Theme C: Interaction and Interdependence": `${getCloudUrl()}/assets/Interaction_and_interdependence.jpg`,
  "Theme D: Continuity and Change": `${getCloudUrl()}/assets/Continuity_and_change.jpg`,
  "Structure 1: Models of the particulate nature of matter": `${getCloudUrl()}/assets/particulate_nature_of_matter.jpeg`,
  "Reactivity 1: What drives chemical reactions?": `${getCloudUrl()}/assets/chemical_reactions.jpeg`,
  "Structure 2: Models of bonding and structure": `${getCloudUrl()}/assets/bonding_and_structure.jpeg`,
  "Reactivity 2: How much, how fast and how far?": `${getCloudUrl()}/assets/composition.jpeg`,
  "Structure 3: Classification of matter": `${getCloudUrl()}/assets/classification_of_matter.jpeg`,
  "Reactivity 3: What are the mechanisms of chemical change?": `${getCloudUrl()}/assets/mechanisms_of_chemical_change.jpeg`,
  "Number and abstract reasoning": `${getCloudUrl()}/assets/number_and_abstract_reasoning.png`,
  "Thinking with models": `${getCloudUrl()}/assets/thinking_with_models.png`,
  "Spatial reasoning": `${getCloudUrl()}/assets/spatial_reasoning.png`,
  "Reasoning with data": `${getCloudUrl()}/assets/reasoning_with_data.png`,
  Evolution: `${getCloudUrl()}/assets/evolution.png`,
  "Interactions between organisms": `${getCloudUrl()}/assets/interactions_between_organisms.png`,
  "Human interactions with environment": `${getCloudUrl()}/assets/human_interactions_with_environment.png`,
  Biotechnology: `${getCloudUrl()}/assets/biotechnology.png`,
};

export const TODDLE_LIBRARY = "TODDLE_LIBRARY";
export const SEARCH_PAGE = "SEARCH_PAGE";
export const BOOKMARKS_PAGE = "BOOKMARKS_PAGE";
export const TOPIC_PAGE = "TOPIC_PAGE";

export const GLOBAL_FILTER = "GLOBAL_FILTER";

export const NEWLY_ADDED_LE_COLLECTION = "NEWLY_ADDED_LE_COLLECTION";
export const MOST_POPULAR_LE_COLLECTION = "MOST_POPULAR_LE_COLLECTION";
export const NEWLY_ADDED_UNIT_PLAN = "NEWLY_ADDED_UNIT_PLAN";
export const MOST_POPULAR_UNIT_PLAN = "MOST_POPULAR_UNIT_PLAN";
export const LIBRARY_TOPIC = "LIBRARY_TOPIC";
export const LIBRARY_TOPIC_LANE = "LIBRARY_TOPIC_LANE";
export const QUESTION_BANK = "QUESTION_BANK";
export const MOST_POPULAR_ASSESSMENT = "MOST_POPULAR_ASSESSMENT";
export const NEWLY_ADDED_ASSESSMENT = "NEWLY_ADDED_ASSESSMENT";

export const TAB_OPTIONS = [
  {
    label: "toddleLibrary:learning_experiences",
    value: ASSESSMENT,
  },
  {
    label: "toddleLibrary:collections",
    value: LE_COLLECTION,
  },
  {
    label: "toddleLibrary:unit_plans",
    value: UNIT_PLAN,
  },
];

export const DP_TAB_OPTIONS = [
  {
    label: "toddleLibrary:practice_worksheets",
    value: WORKSHEET,
  },
  {
    label: "toddleLibrary:mock_exams",
    value: MOCK_EXAM,
  },
  {
    label: "toddleLibrary:questions",
    value: QUESTION,
  },
];

export const MYP_TAB_OPTIONS = [...TAB_OPTIONS, ...DP_TAB_OPTIONS];

export const TAB_OPTION_LABELS = {
  [ASSESSMENT]: "toddleLibrary:learning_experiences",
  [LE_COLLECTION]: "toddleLibrary:collections",
  [UNIT_PLAN]: "toddleLibrary:unit_plans",
  [WORKSHEET]: "toddleLibrary:practice_worksheets",
  [MOCK_EXAM]: "toddleLibrary:mock_exams",
  [QUESTION]: "toddleLibrary:questions",
  [E_ASSESSMENT]: "toddleLibrary:e_assessments",
};

export const locationToTabMap = {
  les: ASSESSMENT,
  collections: LE_COLLECTION,
  "units-section": UNIT_PLAN,
  worksheets: WORKSHEET,
  "mock-exams": MOCK_EXAM,
  questions: QUESTION,
};

export const tabToLocationMap = {
  [ASSESSMENT]: "les",
  [LE_COLLECTION]: "collections",
  [UNIT_PLAN]: "units-section",
  [WORKSHEET]: "worksheets",
  [MOCK_EXAM]: "mock-exams",
  [QUESTION]: "questions",
  [E_ASSESSMENT]: "mock-exams",
};

export const GRADE_1 = "Grade 1";
export const GRADE_2 = "Grade 2";
export const GRADE_3 = "Grade 3";
export const GRADE_4 = "Grade 4";
export const GRADE_5 = "Grade 5";
export const GRADE_6 = "Grade 6";
export const GRADE_7 = "Grade 7";
export const GRADE_8 = "Grade 8";
export const GRADE_9 = "Grade 9";
export const GRADE_10 = "Grade 10";
export const GRADE_11_AND_12 = "Grade 11 & 12";

export const FEATURED_TYPE = "FEATURED";

export const ALL_AREAS_OF_LEARNING = "All areas of learning";
export const ALL_SUBJECTS = "All subjects";

export const EARLY_YEAR_GRADE_LABELS = [
  "1-2 year olds",
  "2-3 year olds",
  "3-4 year olds",
  "4-6 year olds",
];

export const PYP_GRADE_LABELS = [
  ...EARLY_YEAR_GRADE_LABELS,
  GRADE_1,
  GRADE_2,
  GRADE_3,
  GRADE_4,
  GRADE_5,
];

export const MYP_GRADE_LABELS = [GRADE_6, GRADE_7, GRADE_8, GRADE_9, GRADE_10];

export const MYP_SENIOR_GRADE_LABELS = [GRADE_9, GRADE_10];

export const DP_GRADE_LABELS = [GRADE_11_AND_12];

export const UBD_GRADE_LABELS = [...PYP_GRADE_LABELS, ...MYP_GRADE_LABELS];

export const TODDLE_PLAY_URL = "https://play.toddleapp.com";

export const LANE_ITEM_LOCALES = {
  MOST_POPULAR_LE_COLLECTION:
    "toddleLibrary:most_popular_le_collection_for_label",
  NEWLY_ADDED_LE_COLLECTION:
    "toddleLibrary:newly_added_le_collections_for_label",
  MOST_POPULAR_UNIT_PLAN: "toddleLibrary:most_popular_units_for_label",
  NEWLY_ADDED_UNIT_PLAN: "toddleLibrary:newly_added_units_for_label",
  QUESTION_BANK: "toddleLibrary:question_bank_for_label",
  MOCK_EXAM: "toddleLibrary:mock_exams_for_label",
  PRACTICE_WORKSHEET: "toddleLibrary:practice_worksheets_for_label",
  MYP_MOCK_EXAM: "toddleLibrary:e_assessments_for_label",
  MYP_PRACTICE_WORKSHEET: "toddleLibrary:criterion_based_assessments_for_label",
  MOST_POPULAR_ASSESSMENT: "toddleLibrary:most_popular_assessments_for_label",
  NEWLY_ADDED_ASSESSMENT: "toddleLibrary:newly_added_assessments_for_label",
};

export const COUNT_ENTITY_MAP = {
  le: ASSESSMENT,
  unitPlan: UNIT_PLAN,
  leCollection: LE_COLLECTION,
  worksheet: WORKSHEET,
  mockExam: MOCK_EXAM,
  question: QUESTION,
  eAssessment: E_ASSESSMENT,
};

export const THREE_DOTS = "...";

export const CATEGORISED_ENTITY_MAP = {
  ASSESSMENT: "le",
  UNIT_PLAN: "unitPlan",
  LE_COLLECTION: "leCollection",
  WORKSHEET_ASSESSMENT: "worksheet",
  MOCK_EXAM: "mockExam",
  QUESTION: "question",
  QUESTION_V2: "questionV2",
  E_ASSESSMENT: "eAssessment",
};

export const ROUTE_TO_ENTITY_MAP = {
  collections: LE_COLLECTION,
  "units-section": UNIT_PLAN,
  les: ASSESSMENT,
  worksheets: WORKSHEET,
  "mock-exams": MOCK_EXAM,
  questions: QUESTION,
};

export const SEARCH_PRIORITY = [
  "le",
  "leCollection",
  "unitPlan",
  "worksheet",
  "mockExam",
  "question",
  "eAssessment",
];

export const UNIT_FEED_FILTERS = "unit-feed-filters";
export const LE_FEED_FILTERS = "le-feed-filters";
export const LE_COLLECTION_FEED_FILTERS = "le-collection-feed-filters";

export const WORKSHEET_FEED_FILTERS = "worksheet-feed-filters";
export const WORKSHEET_SEARCH_FILTERS = "worksheet-search-filters";
export const WORKSHEET_TOPICS_FILTERS = "worksheet-topics-filters";

export const QUESTION_FEED_FILTERS = "question-feed-filters";
export const QUESTION_SEARCH_FILTERS = "question-search-filters";
export const QUESTION_TOPICS_FILTERS = "question-topics-filters";

export const WORKSHEET_QUESTIONS_STORAGE_KEYS = [
  WORKSHEET_FEED_FILTERS,
  WORKSHEET_SEARCH_FILTERS,
  WORKSHEET_TOPICS_FILTERS,
  QUESTION_FEED_FILTERS,
  QUESTION_SEARCH_FILTERS,
  QUESTION_TOPICS_FILTERS,
];

export const SEARCH_PAGE_FILTERS = {
  WORKSHEET: WORKSHEET_SEARCH_FILTERS,
  QUESTION: QUESTION_SEARCH_FILTERS,
};
export const TOPICS_PAGE_FILTERS = {
  WORKSHEET: WORKSHEET_TOPICS_FILTERS,
  QUESTION: QUESTION_TOPICS_FILTERS,
};

export const LANE_ITEM_STORAGE_FILTERS = {
  NEWLY_ADDED_LE_COLLECTION: LE_COLLECTION_FEED_FILTERS,
  MOST_POPULAR_LE_COLLECTION: LE_COLLECTION_FEED_FILTERS,
  NEWLY_ADDED_UNIT_PLAN: UNIT_FEED_FILTERS,
  MOST_POPULAR_UNIT_PLAN: UNIT_FEED_FILTERS,
};

export const TOTAL_COUNT_MAP = {
  LE_COLLECTION: "collections_with_count",
  UNIT_PLAN: "unit_plans_with_count",
  ASSESSMENT: "learning_experiences_with_count",
  WORKSHEET: "worksheets_with_count",
  QUESTION: "questions_with_count",
  MOCK_EXAM: "mock_exam_paper_with_count",
  MYP_MOCK_EXAM: "e_assessments_with_count",
  MYP_WORKSHEET: "criterion_based_assessments_with_count",
};

export const SUBJECT_ABBREVIATION_MAP = {
  [_.lowerCase(
    MATHEMATICS_ANALYSIS_AND_APPROACHES
  )]: MATHEMATICS_ANALYSIS_AND_APPROACHES_ABBREVIATION,
  [_.lowerCase(
    MATHEMATICS_APPLICATIONS_AND_INTERPRETATION
  )]: MATHEMATICS_APPLICATIONS_AND_INTERPRETATION_ABBREVIATION,
  [_.lowerCase(ENGLISH_A)]: ENGLISH_A_ABBREVIATION,
};

export const HOMEPAGE = "Homepage";

export const LE_VIEW = "LE View";

export const UNIT_VIEW = "Unit View";

export const QUESTION_VIEW = "Question View";

export const IMPORT_WORKSHEET_FROM_TODDLE_LIBRARY =
  "IMPORT_WORKSHEET_FROM_TODDLE_LIBRARY";

export const MOCK_EXAM_VIEW = "Mock Exam View";

export const CONTEXT_CURRICULUM_PROGRAM_ID = "contextCurriculumProgramId";

export const MYP_FILTER_ENTITIES = {
  MYP_RELATED_CONCEPT: "MYP_RELATED_CONCEPT",
  MYP_KEY_CONCEPT: "MYP_KEY_CONCEPT",
  MYP_GLOBAL_CONTEXT: "MYP_GLOBAL_CONTEXT",
  MYP_LIBRARY_TOPICS: "MYP_LIBRARY_TOPICS",
};

export const MYP_LEARNING_OBJECTIVES = "MYP_LEARNING_OBJECTIVES";

export const IB_MYP_CURRICULUM_PROGRAM = "IB_MYP_CURRICULUM_PROGRAM";

export const TOPIC_DEPTH = 1;
export const SUB_TOPIC_DEPTH = 2;

export const WORKSHEET_FILTERS = {
  topics: [],
  subTopics: [],
  relatedConcepts: [],
  globalContext: [],
  keyConcepts: [],
  questionTypes: [],
  criterion: [],
};
export const QUESTION_FILTERS = {
  topics: [],
  subTopics: [],
  difficulty: [],
  paperTypes: [],
  relatedConcepts: [],
  globalContext: [],
  keyConcepts: [],
  questionTypes: [],
  criterion: [],
  hidePrevious: false,
};

export const FEED_SECTION_HEADER_LOCALES = {
  WITH_SEARCH: {
    UNIT_PLAN: "toddleLibrary:unit_plans_with_count_and_search",
    LEARNING_EXPERIENCE:
      "toddleLibrary:learning_experiences_with_count_and_search",
    LE_COLLECTION: "toddleLibrary:collections_with_count_and_search",
    WORKSHEET: "toddleLibrary:worksheets_with_count_and_search",
    CRITERION_BASED_ASSESSMENT:
      "toddleLibrary:criterion_based_assessments_with_count_and_search",
    QUESTION: "toddleLibrary:questions_with_count_and_search",
    MOCK_EXAM: "toddleLibrary:mock_exam_paper_with_count_and_search",
    E_ASSESSMENT: "toddleLibrary:e_assessments_with_count_and_search",
  },
  WITHOUT_SEARCH: {
    UNIT_PLAN: "toddleLibrary:unit_plans_with_count",
    LEARNING_EXPERIENCE: "toddleLibrary:learning_experiences_with_count",
    LE_COLLECTION: "toddleLibrary:collections_with_count",
    WORKSHEET: "toddleLibrary:worksheets_with_count",
    CRITERION_BASED_ASSESSMENT:
      "toddleLibrary:criterion_based_assessments_with_count",
    QUESTION: "toddleLibrary:questions_with_count",
    MOCK_EXAM: "toddleLibrary:mock_exam_paper_with_count",
    E_ASSESSMENT: "toddleLibrary:e_assessments_with_count",
  },
};
